module.exports = __webpack_public_path__ + "img/career-history.901a2e3a.svg";